// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2_KCY","bigColWidth":"Table_bigColWidth__3euTX","biggerColWidth":"Table_biggerColWidth__3z4kq","row":"Table_row__2eT2Y","col":"Table_col__1-NjS"};